import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ChefHat, User, Plus, Menu, X, ChevronDown, Check, Globe } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { mockUser, categories } from '../data/mockData';
import styles from './Header.module.css';
import logo from '../assets/chef-cap.png';
import axios from 'axios';
import { getCategoriesApi } from '../http/api';
import { useDispatch, useSelector } from "react-redux";
import { useTranslate } from './UseTranslate';
import {changeLanguage } from '../Slices/LangSlice'

const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Français' },
];

export function Header() {

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [categoriesOpen, setCategoriesOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [langOpen, setLangOpen] = useState(false);

  const {t} = useTranslate()

  const {language} = useSelector((state) => state.language);

  const navigate = useNavigate();
  const isLoggedIn = true; 

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);




   const fetchCategories=async()=> {
    try{
      const response = await axios.get(getCategoriesApi(language)); // Replace 'en' with the desired language
      console.log(response.data,"categories");
      setCategories(response?.data?.categories);
    }
    catch(err){
      console.log(err);
    }
  }

  useEffect(() => {
    fetchCategories();
  },[])


  useEffect(() => {
    if (!langOpen) return;
    const close = () => setLangOpen(false);
    document.addEventListener('click', close);
    return () => document.removeEventListener('click', close);
  }, [langOpen]);

  const dispatch = useDispatch()




  const closeMenus = () => {
    setMobileMenuOpen(false);
    setCategoriesOpen(false);
  };

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <div className={styles.inner}>

          {/* Logo */}
          <Link to="/" className={styles.logo}>
            <motion.img
              src={logo}
              alt="Food Box"
              className={styles.logoImg}
              whileHover={{ rotate: [-6, 6, -6] }}
              transition={{ duration: 0.5 }}
            />
            <span className={styles.logoText}>UVFood Box</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className={styles.nav}>
            
            <Link to="/" className={styles.navLink}>
              {t('Home')}
              <motion.div
                className={styles.navUnderline}
                initial={{ scaleX: 0 }}
                whileHover={{ scaleX: 1 }}
                transition={{ duration: 0.2 }}
              />
            </Link>

            {/* Categories Dropdown (FIXED: hover removed) */}
            <div className={styles.dropdownWrapper}>
              <button
                className={styles.dropdownBtn}
                type="button"
                aria-haspopup="menu"
                aria-expanded={categoriesOpen}
                onClick={() => setCategoriesOpen((v) => !v)}
              >
                {t('Categories')}
                <motion.div
                  animate={{ rotate: categoriesOpen ? 180 : 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <ChevronDown className={styles.chevron} />
                </motion.div>
              </button>

              <AnimatePresence>
                {categoriesOpen && (
                  <motion.div
                    initial={{ y: -120, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: -120, opacity: 0 }}
                    transition={{ duration: 0.4 }}
                    className={styles.dropdownMenu}
                  >
                    <div className={styles.dropdownContent}>
                      {categories.map((category) => (
                        <Link
                          key={category.id}
                          to={`/category/${category.id}`}
                          className={styles.dropdownItem}
                          onClick={closeMenus}
                        >
                          <span className={styles.dropdownEmoji}>
                            <ChefHat className={styles.dropdownEmojiIcon} />
                          </span>
                          <span className={styles.dropdownLabel}>{category.category_name}</span>
                        </Link>
                      ))}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>

            {/* <Link to="/about" className={styles.navLink}>
              About
              <motion.div
                className={styles.navUnderline}
                initial={{ scaleX: 0 }}
                whileHover={{ scaleX: 1 }}
                transition={{ duration: 0.2 }}
              />
            </Link> */}
            
             <div className={styles.langWrapper} onClick={(e) => e.stopPropagation()}>
                  <button
                    type="button"
                    className={styles.langBtn}
                    onClick={() => setLangOpen((prev) => !prev)}
                    aria-haspopup="listbox"
                    aria-expanded={langOpen}
                    aria-label="Change language"
                  >
                    <Globe className={styles.langIcon} />
                    <span>{LANGUAGES.find((l) => l.code === language)?.label || language}</span>
                    <ChevronDown className={`${styles.langChevron} ${langOpen ? styles.langChevronOpen : ''}`} />
                  </button>

                  <AnimatePresence>
                    {langOpen && (
                      <motion.ul
                        className={styles.langMenu}
                        role="listbox"
                        initial={{ opacity: 0, y: -8 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -8 }}
                        transition={{ duration: 0.15 }}
                      >
                        {LANGUAGES.map((lang) => (
                          <li key={lang.code} role="option" aria-selected={language === lang.code}>
                            <button
                              type="button"
                              className={`${styles.langItem} ${language === lang.code ? styles.langItemActive : ''}`}
                              onClick={() => {
                                dispatch(changeLanguage(lang.code));
                                setLangOpen(false);
                              }}
                            >
                              <span>{lang.label}</span>
                              {language === lang.code && <Check className={styles.langCheck} />}
                            </button>
                          </li>
                        ))}
                      </motion.ul>
                    )}
                  </AnimatePresence>
                </div>






            {isLoggedIn ? (
              <>
                <motion.button
                  onClick={() => {
                    closeMenus();
                    navigate('/add-recipe');
                  }}
                  whileHover={{ scale: 1.05, y: -2 }}
                  whileTap={{ scale: 0.95 }}
                  className={styles.addBtn}
                  type="button"
                >
                  <Plus className={styles.addIcon} />
                  Add Recipe
                </motion.button>

                <Link to="/profile" className={styles.profileLink} onClick={closeMenus}>
                  <motion.img
                    whileHover={{ scale: 1.1, rotate: 5 }}
                    transition={{ type: 'spring', stiffness: 300 }}
                    src={mockUser.avatar}
                    alt={mockUser.name}
                    className={styles.profileImg}
                  />
                </Link>
              </>
            ) : (
              <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                <Link to="/login" className={styles.loginBtn} onClick={closeMenus}>
                  <User className={styles.loginIcon} />
                  Login
                </Link>
              </motion.div>
            )}
          </nav>

          {/* Mobile Menu Button */}
          <motion.button
            whileTap={{ scale: 0.9 }}
            onClick={() => setMobileMenuOpen((v) => !v)}
            className={styles.mobileBtn}
            type="button"
            aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
          >
            {mobileMenuOpen ? (
              <X className={styles.mobileIcon} />
            ) : (
              <Menu className={styles.mobileIcon} />
            )}
          </motion.button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className={styles.mobileMenu}
          >
            <div className={styles.mobileContent}>

              <Link
                to="/"
                className={styles.mobileLink}
                onClick={closeMenus}
              >
                Home
              </Link>

              <div className={styles.mobileSectionTitle}>Categories</div>

              <div className={styles.mobileCategories}>
                {categories.map((category, index) => (
                  <motion.div
                    key={category.id}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: index * 0.05 }}
                  >
                    <Link
                      to={`/category/${category.id}`}
                      className={styles.mobileCategoryLink}
                      onClick={closeMenus}
                    >
                      <div className={styles.mobileCategoryImgWrapper}>
                        <img
                          src={category.image_url}
                          alt={category.name}
                          className={styles.mobileCategoryImg}
                        />
                      </div>
                      <span>{category.category_name}</span>
                    </Link>
                  </motion.div>
                ))}
              </div>

              {/* <Link
                to="/about"
                className={styles.mobileLink}
                onClick={closeMenus}
              >
                About
              </Link> */}

              {isLoggedIn ? (
                <>
                  <Link
                    to="/add-recipe"
                    className={styles.mobileLink}
                    onClick={closeMenus}
                  >
                    <Plus className={styles.mobileIconSmall} />
                    Add Recipe
                  </Link>

                  <Link
                    to="/profile"
                    className={styles.mobileLink}
                    onClick={closeMenus}
                  >
                    <User className={styles.mobileIconSmall} />
                    Profile
                  </Link>
                </>
              ) : (
                <Link
                  to="/login"
                  className={styles.mobileLoginLink}
                  onClick={closeMenus}
                >
                  <User className={styles.mobileIconSmall} />
                  Login
                </Link>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}